import React from 'react';

const ErrorMessage = ({ children }) => (
  <div className="form-error">{children}</div>
);

export default ErrorMessage;
